import { createRouter, createWebHistory } from 'vue-router'
import { getRouterConfig } from './router.config'
import { setupRouterGuards } from './guards'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: getRouterConfig(),
  scrollBehavior() {
    return { top: 0, behavior: 'instant' }
  },
})

// 设置路由守卫
setupRouterGuards(router)

export default router
